<div class="auto">
  <div class="auth-wrapper">
    <div class="card">

      <div class="text-center">
        <h2 class="title">Legal Details</h2>
        <p class="subtitle">
          Provide your PAN details for verification and compliance
        </p>
      </div>

      <form [formGroup]="legalForm" (ngSubmit)="submit()">

        <div class="form-row">

          <div class="form-group">
            <label>PAN Card Number <small class="required error">*</small></label>

            <input type="text" formControlName="panNumber" placeholder="ABCDE1234F" maxlength="10"
              (input)="onPanInput($event)" />


            <div *ngIf="legalForm.get('panNumber')?.touched && legalForm.get('panNumber')?.invalid">

              <small class="error" *ngIf="legalForm.get('panNumber')?.errors?.['required']">
                PAN is required
              </small>

              <small class="error" *ngIf="legalForm.get('panNumber')?.errors?.['pattern']">
                Invalid PAN format (Example: ABCDE1234F)
              </small>


            </div>
          </div>

        </div>

        <div class="form-group">
          <label>PAN Card Copy <span class="required error">*</span></label>

          <input type="file" id="panFile" hidden accept="image/*,application/pdf,.png,.jpg,.jpeg"
            (change)="onFileSelect($event)" />

          <div class="file-box">
            <!-- <span class="file-name">
              {{ selectedFileName || 'Choose file...' }}
            </span>

            <button type="button" class="browse-btn" (click)="triggerFile()">
              Browse
            </button> -->
            <span class="file-name" *ngIf="!formfillNext">
              <!-- {{ selectedFileName || 'Choose file...' }} -->

              {{
              selectedFileName
              ? (
              selectedFileName.length > 20
              ? (selectedFileName.slice(0,20) + '' +
              selectedFileName.slice(selectedFileName.lastIndexOf('.')))
              : selectedFileName
              )
              : 'Choose file...'
              }}
            </span>

            <span class="file-name" *ngIf="formfillNext" >
              <a [href]=selectedFileName target="_blank"  style="text-decoration: none;" >VIEW PAN</a>
              <!-- data-bs-toggle="modal" data-bs-target="#exampleModal" -->
            </span>

            <button type="button" class="browse-btn" (click)="triggerFile()" *ngIf="!formfillNext">
              Browse
            </button>

          </div>

          <!-- <small class="error mt-2"
            *ngIf="(legalForm.get('panFile')?.touched || submitted) && legalForm.get('panFile')?.invalid">
            PAN card file is required
          </small> -->
          <small class="error mt-2" *ngIf="(legalForm.get('panFile')?.touched || submitted) && legalForm.get('panFile')?.errors?.['required']">
            PAN card file is required
          </small>

          <small class="error mt-2" *ngIf="legalForm.get('panFile')?.errors?.['invalidType']">
            Only JPG, PNG, PDF files allowed
          </small>

          <small class="error mt-2" *ngIf="legalForm.get('panFile')?.errors?.['maxSize']">
            File size must be less than 3MB
          </small>

        </div>

        <div class="note-box">
          <strong>Note:</strong>
          Please ensure the PAN card copy is clear and all details are readable.
          Accepted formats: JPG, PNG, PDF (max 3MB)
        </div>

        <hr />

        <!-- Buttons -->
        <div class="button-row">
          <button type="button" class="secondary-btn" (click)="back()"> Back </button>

          <button type="submit" class="primary-btn" *ngIf="!formfillNext"> Continue </button>
          <button type="button" class="primary-btn" (click)="next()" *ngIf="formfillNext"> Next </button>

          <!-- <button type="submit" class="primary-btn "> Continue </button> -->
        </div>


      </form>

    </div>
    <div class="step-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot active"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </div>

</div>

<div class="logout">
  <button (click)="logout()" class="primary-btn">Logout</button>
</div>


<!-- Medium Modal -->



<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">VIEW PAN</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">

        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
          Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
          nisi ut aliquip ex ea commodo consequat.
        </p>

        <img src="https://staging-assets.tikiti.in/TIKITI/images/category/music.svg" class="img-fluid " alt="Sample Image">
         <!-- <iframe [src]=selectedFileName frameborder="0"></iframe> -->
        
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
